import jsPDF from "jspdf";

function randomDate(start, end) {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
}

function randomBatchNo() {
    return "B" + Math.floor(100 + Math.random() * 900);
}

function randomQR() {
    return "CAC" + Math.floor(12000 + Math.random() * 90000) + "SR";
}

function randomSKU() {
    return "SKU" + (Math.floor(Math.random() * 10) % 3) + 1;
}

function generateData(count = 1000) {

    const start = new Date("2020-01-01");
    const end = new Date("2026-12-31");

    const result = [];

    for (let i = 0; i < count; i++) {

        const date = randomDate(start, end);

        const batchCount = Math.floor(Math.random() * 5);

        const batch = [];

        for (let j = 0; j < batchCount; j++) {

            const ts = randomDate(start, end);

            batch.push({
                batch_no: randomBatchNo(),
                date_of_manufacturing:
                    ts.getFullYear() + "-" + String(ts.getMonth() + 1).padStart(2, "0"),
                timestamp: ts.toISOString()
            });
        }

        result.push({
            batch: batch,
            qr_creation_date: date.toUTCString(),
            qr_id: randomQR(),
            sku_id: randomSKU()
        });
    }

    return result;
}

export const generateQRAnalyticsReport = (records = [], product, year, logs) => {

    // records = generateData(1000);

    const doc = new jsPDF();

    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    let cursorY = 20;

    const getY = () => cursorY;
    const setY = v => cursorY = v;

    const ensureSpace = (space) => {
        if (cursorY + space > pageHeight - 20) {
            addFooter(doc);
            doc.addPage();
            cursorY = 20;
        }
    };

    /* ---------------- HEADER ---------------- */

    const renderHeader = () => {
        const companyLogoBase64 = "logo.png";

        // Header with logo
        doc.setFillColor(255, 255, 255);
        doc.rect(0, 0, 210, 35, 'F');

        // Add company logo if available
        if (companyLogoBase64) {
            try {
                doc.addImage(companyLogoBase64, 'PNG', 7, 5, 30, 25);
                doc.addImage("QRmor.jpeg", "PNG", 177, 5, 30, 25);
            } catch (e) {
                console.error('Error adding company logo:', e);
            }
        }

        doc.setTextColor(0);
        doc.setFontSize(18);
        doc.setFont(undefined, "bold");
        doc.text("QR GENERATION & TRACEABILITY REPORT", 108, 16, { align: "center" });

        doc.setFontSize(9);
        doc.setFont(undefined, "normal");
        doc.text(
            `Generated: ${formatDateTime(new Date())} | ${sessionStorage.getItem("name") || ""}`,
            120,
            24,
            { align: "center" }
        );
        const textParts = [];

        if (product !== 'all') {
            textParts.push(`Product: ${product}`);
        }

        if (year) {
            textParts.push(`Year: ${year.getFullYear()}`);
        }

        doc.text(
            textParts.join(" | "),
            120,
            30,
            { align: "center" }
        );

        doc.setTextColor(0);
        cursorY = 38;
    };

    const formatDateTime = (date) => {
        if (!date) return "";
        const d = new Date(date);
        return d.toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        });
    };

    /* ---------------- FOOTER ---------------- */

    const addFooter = (doc) => {
        const COLORS = {
            navy: [30, 42, 71],
            slate: [52, 73, 94],
            lightBg: [246, 248, 252],
            line: [220, 226, 235],

            green: [109, 158, 91],
            red: [224, 102, 102],
            amber: [249, 168, 37],

            text: [25, 30, 40],
            muted: [110, 120, 135],
            white: [255, 255, 255]
        };

        const PAGE_W = 210;
        
        const pages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pages; i++) {
            doc.setPage(i);

            doc.setFontSize(9);
            doc.setTextColor(...COLORS.muted);

            doc.text("Confidential – Internal Use Only", PAGE_W / 2, 286, { align: "center" });
            doc.text(`Page ${i} of ${pages}`, PAGE_W / 2, 291, { align: "center" });

            // branding line
            doc.setFontSize(8);
            doc.text("QRmor Asset Security Analytics Report", PAGE_W - 12, 283, { align: "right" });
            doc.text("© 2026 Scinova Scientifics | Powered by CIIRC®", PAGE_W - 12, 288, { align: "right" });
        }

        doc.setTextColor(...COLORS.text);
    };

    /* ---------------- SECTION TITLE ---------------- */

    /* ---------------- SECTION CONTAINER ---------------- */

    const renderSectionContainer = (height = 40) => {

        ensureSpace(height + 10);

        const y = getY() - 2;

        doc.setFillColor(245, 245, 245);
        doc.roundedRect(
            10,
            y,
            pageWidth - 20,
            height,
            4,
            4,
            "F"
        );
    };

    const renderSectionTitle = (title) => {

        doc.setTextColor(0)
        const y = getY();

        doc.setFontSize(13);
        doc.setFont(undefined, "bold");

        doc.text(title, 18, y + 6);

        setY(y + 10);
    };

    /* ---------------- SUMMARY CARDS ---------------- */

    const renderSummaryCards = (stats) => {

        ensureSpace(50);

        const cards = [
            { title: "Total QRs", value: stats.totalQRs },
            { title: "Distinct Products", value: stats.distinctSkus },
            { title: "Batch Linked", value: stats.batchLinked },
            { title: "No Batch", value: stats.totalQRs - stats.batchLinked }
        ];

        const cardW = 42;
        const cardH = 22;

        const startX = 12;
        const gap = 5;

        const y = getY();

        cards.forEach((c, i) => {

            const row = Math.floor(i / 4);
            const col = i % 4;

            const x = startX + col * (cardW + gap);
            const cy = y + row * (cardH + 6);

            doc.setFillColor(245, 247, 250);
            doc.roundedRect(x, cy, cardW, cardH, 3, 3, "F");

            doc.setDrawColor(220);
            doc.roundedRect(x, cy, cardW, cardH, 3, 3);

            doc.setFontSize(9);
            doc.text(c.title.toUpperCase(), x + 5, cy + 7);

            doc.setFontSize(16);
            doc.text(String(c.value), x + 5, cy + 16);
        });

        setY(y + 35);
    };

    /* ---------------- INLINE BARS ---------------- */

    const renderInlineBars = (title, map) => {

        const entries = Object.entries(map);

        renderSectionContainer(entries.length * 13 + 10);
        renderSectionTitle(title);

        if (!entries.length) return;

        const max = Math.max(...entries.map(e => e[1]));
        const maxBarWidth = 90;

        entries.forEach(([label, value]) => {

            ensureSpace(10);

            const y = getY() + 5;

            doc.setFontSize(10);
            doc.text(label, 15, y);

            const barWidth = (value / max) * maxBarWidth;

            doc.setFillColor(79, 129, 189);
            doc.rect(55, y - 4, barWidth, 5, "F");

            doc.text(String(value), 150, y);

            setY(y + 8);
        });

        setY(getY() + 4);
    };

    /* ---------------- YEAR vs MONTH HEATMAP ---------------- */

    function drawHeatMap(matrix, doc, startY) {

        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const cellW = 14;
        const cellH = 8;
        const startX = 30;

        const years = Object.keys(matrix).sort();

        // find max value for normalization
        let maxValue = 0;
        years.forEach(year => {
            matrix[year].forEach(v => {
                if (v > maxValue) maxValue = v;
            });
        });

        if (maxValue === 0) maxValue = 1;

        // draw month headers
        doc.setFontSize(9);
        months.forEach((m, i) => {
            doc.text(m, startX + i * cellW + 2, startY);
        });

        let y = startY + 8;

        years.forEach(year => {

            doc.setFontSize(9);

            // year label
            doc.text(String(year), startX - 15, y - 1);

            matrix[year].forEach((value, monthIndex) => {

                const intensity = value / maxValue;

                let r, g, b = 120;   // add blue component to soften colors

                if (intensity < 0.5) {
                    // soft green → pale yellow
                    r = 120 + Math.floor(120 * (intensity * 2));
                    g = 200 + Math.floor(40 * (intensity * 2));
                } else {
                    // pale yellow → soft red
                    r = 220 + Math.floor(35 * (intensity - 0.5) * 2);
                    g = 220 - Math.floor(140 * (intensity - 0.5) * 2);
                }

                doc.setFillColor(r, g, b);

                const x = startX + monthIndex * cellW;

                doc.roundedRect(x, y - 5, cellW - 2, cellH - 2, 1.5, 1.5, "F");

                // value text
                if (value > 0) {
                    doc.setFontSize(7);
                    doc.setTextColor(0);
                    doc.text(String(value), x + 5, y - 1);
                }

            });

            y += cellH;

        });

    }
    const renderYearMonthHeatmap = (monthMap) => {

        const monthOrder = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        const years = Object.keys(monthMap).sort();

        const cellW = 14;
        const cellH = 8;

        ensureSpace((years.length + 3) * 10);

        let startY = getY() + 5;
        let startX = 30;

        doc.setFontSize(10);
        doc.setFont(undefined, "bold");

        /* ---- Month Labels ---- */

        monthOrder.forEach((m, i) => {
            doc.text(m, startX + i * cellW + 2, startY);
        });

        startY += 4;

        /* ---- Find max value for color scale ---- */

        let max = 0;

        years.forEach(year => {
            monthOrder.forEach(month => {
                const val = (monthMap[year] && monthMap[year][month]) || 0;
                if (val > max) max = val;
            });
        });

        /* ---- Draw Grid ---- */

        years.forEach((year, rowIndex) => {

            const y = startY + rowIndex * cellH + 5;

            doc.setFontSize(9);
            doc.setFont(undefined, "bold");

            doc.text(year, 15, y);

            monthOrder.forEach((month, colIndex) => {

                const val = (monthMap[year] && monthMap[year][month]) || 0;

                const intensity = max ? val / max : 0;

                // intensity should be between 0 and 1
                // intensity between 0 and 1
                let r, g, b = 120;   // add blue component to soften colors

                if (intensity < 0.5) {
                    // soft green → pale yellow
                    r = 120 + Math.floor(120 * (intensity * 2));
                    g = 200 + Math.floor(40 * (intensity * 2));
                } else {
                    // pale yellow → soft red
                    r = 220 + Math.floor(35 * (intensity - 0.5) * 2);
                    g = 220 - Math.floor(140 * (intensity - 0.5) * 2);
                }

                doc.setFillColor(r, g, b);

                const x = startX + colIndex * cellW;

                doc.roundedRect(x, y - 5, cellW - 2, cellH - 2, 1.5, 1.5, "F");

                doc.setFontSize(7);
                doc.setTextColor(0);

                if (val > 0) {
                    doc.text(String(val), x + 5, y - 1);
                }

            });

        });

        setY(startY + years.length * cellH + 10);
    };

    /* ---------------- TABLE ---------------- */

    const renderTable = (title, headers, rows) => {

        renderSectionTitle(title);

        const colWidth = (pageWidth - 30) / headers.length;

        ensureSpace(10);

        let y = getY() + 5;

        doc.setFillColor(30, 42, 71);
        doc.rect(15, y - 5, pageWidth - 30, 7, "F");

        doc.setTextColor(255);
        doc.setFontSize(10);

        headers.forEach((h, i) => {
            doc.text(h, 17 + colWidth * i, y);
        });

        setY(y + 7);

        rows.forEach((row, idx) => {

            ensureSpace(8);

            y = getY();

            if (idx % 2 === 0) {
                doc.setFillColor(245, 247, 250);
                doc.rect(15, y - 5, pageWidth - 30, 7, "F");
            }

            doc.setTextColor(0);

            row.forEach((cell, i) => {
                doc.text(String(cell), 17 + colWidth * i, y);
            });

            setY(y + 7);
        });

        setY(getY() + 4);
    };


    function groupBySKU(data) {

        const skuMap = {};

        data.forEach(item => {
            const sku = item.sku_id;

            if (!skuMap[sku]) {
                skuMap[sku] = [];
            }

            skuMap[sku].push(item);
        });

        // sort SKUs alphabetically
        const sorted = {};

        Object.keys(skuMap)
            .sort((a, b) => a.localeCompare(b))
            .forEach(sku => {
                sorted[sku] = skuMap[sku];
            });

        return sorted;
    }

    function buildHeatmapMatrix(records) {
        const matrix = {};

        records.forEach(item => {
            const date = new Date(item.qr_creation_date);
            const year = date.getFullYear();
            const month = date.getMonth(); // 0-11

            if (!matrix[year]) {
                matrix[year] = new Array(12).fill(0);
            }

            matrix[year][month]++;
        });

        return matrix;
    }
    /* ---------------- DATA AGGREGATION ---------------- */

    const totalQRs = records.length;

    const skuSet = new Set();
    let yearMap = {};
    const skuMap = {};
    const monthMap = {};

    let batchLinked = 0;

    const tableRows = [];

    records.forEach(r => {

        const date = new Date(r.qr_creation_date);

        const year = date.getFullYear();
        const month = date.toLocaleString("default", { month: "short" });

        const sku = r.sku_id || "Unknown";

        skuSet.add(sku);

        /* year counts */
        yearMap[year] = (yearMap[year] || 0) + 1;

        /* sku counts */
        skuMap[sku] = (skuMap[sku] || 0) + 1;

        /* monthly counts */
        if (!monthMap[year]) monthMap[year] = {};
        monthMap[year][month] = (monthMap[year][month] || 0) + 1;

        /* batch detection */
        let batchNo = "-";

        if (r.batch && r.batch.length) {

            batchLinked++;

            batchNo = r.batch[0].batch_no;
        }

        tableRows.push([
            r.qr_id,
            sku,
            batchNo,
            formatDateTime(date)
        ]);
    });

    const distinctSkus = skuSet.size;

    /* ---------------- REPORT BUILD ---------------- */

    renderHeader();

    renderSectionContainer(40);
    renderSectionTitle("Executive Summary");

    renderSummaryCards({
        totalQRs,
        distinctSkus,
        batchLinked
    });

    if (!year) {
        renderInlineBars(
            "Year-wise QR Generation",
            yearMap
        );
    }

    const sortedSkuMap = Object.fromEntries(
        Object.entries(skuMap)
            .sort((a, b) => b[1] - a[1])
    );

    if (product === 'all')
        renderInlineBars(
            "Product-wise QR Generation",
            sortedSkuMap
        );
    const skuGroups = groupBySKU(records);

    ensureSpace(Object.keys(skuGroups).length * 10 + 10)
    renderSectionTitle("Year vs. Month QR Generation");
    Object.keys(skuGroups).forEach((sku, index) => {

        const matrix = buildHeatmapMatrix(skuGroups[sku]);
        ensureSpace(Object.keys(matrix).length * 8 + 15)
        doc.setTextColor(0)
        renderSectionContainer(Object.keys(matrix).length * 8 + 15);
        doc.setFontSize(12);
        doc.text(`Product: ${sku}`, 20, getY() + 5);

        drawHeatMap(matrix, doc, getY() + 10);

        setY(getY() + Object.keys(matrix).length * 8 + 20);

    });
    if (logs) {
        ensureSpace(50)
        renderTable(
            "Detailed QR-Batch Records",
            ["QR ID", "SKU", "Batch", "Creation Date"],
            tableRows
        );

    }
    addFooter(doc);


    doc.setTextColor(0);
    doc.text("End of Report", 105, getY() + 20, { align: "center" });

    doc.text('__________________________', 150, getY() + 45);
    doc.text('Authorized Signatory', 160, getY() + 50);

    window.open(doc.output("bloburl"), "_blank");
};